import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Typography, Paper, List, ListItem, ListItemAvatar, Avatar, ListItemText } from "@mui/material";
import axios from "axios";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";

const API_URL = process.env.REACT_APP_API_URL;

const ParticipantsPage = () => {
  const { postId } = useParams();
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      window.scrollTo(0, 0);  // Scroll to top when this page is loaded
    }, []);

  useEffect(() => {
    if (!postId) return;

    axios
      .get(`${API_URL}/posts/participants/`, { params: { postId } })
      .then((res) => {
        setParticipants(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        alert(err.response?.data?.error || "Failed to fetch participants");
      });
  }, [postId]);

  if (loading) return <p>Loading participants...</p>;

  return (
    <div>
      <Header1 />
      <Container maxWidth="sm" sx={{ mt: 5 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h3" fontWeight="bold" mb={3} textAlign="center">
            Participants
          </Typography>

          {participants.length === 0 ? (
            <Typography>No participants for this post yet.</Typography>
          ) : (
            <List>
              {participants.map((user, idx) => (
                <ListItem key={idx}>
                  <ListItemAvatar>
                    <Avatar src={user.profile_pic || ""}>
                      {user.name?.[0] || "U"}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={`${user.name} ${user.surname || ""}`} />
                </ListItem>
              ))}
            </List>
          )}
        </Paper>
      </Container>
      <Footer2 />
    </div>
  );
};

export default ParticipantsPage;
